import { Column } from "@shared-ui-components/DataTable/types";
import {
  formatNumberWithComma,
  formatNumberWithCommaAndDollar,
} from "@src/constants";
import { Product } from "../ProductMixRevenueBreakdown/type";

// Functions
export const refineData = (data: Product[]) => {
  const refined = data?.map((el: Product) => {
    const refinedObject = {
      name: el.name,
      cost: el.cost,
      margin: el.margin,
      qty: el.qty,
      revenue: el.revenue,
      total: el.total,
    };
    return refinedObject;
  });
  return refined;
};

// Constants
export const columns: Column[] = [
  { id: "name", label: "Name", minWidth: 106, showTooltip: true },
  {
    id: "qty",
    label: "QTY",
    minWidth: 76,
    align: "left",
    format: formatNumberWithComma,
  },
  {
    id: "revenue",
    label: "Sales",
    minWidth: 76,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 76,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "margin",
    label: "Margin",
    minWidth: 94,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
];
